import { Capacitor } from '@capacitor/core';

// Capacitor's checks are pure runtime — safe to call from module scope. We
// cache them once so platform-conditional render paths don't read globals on
// every component mount.
export const isNative = Capacitor.isNativePlatform();
export const isIOS = Capacitor.getPlatform() === 'ios';
export const isAndroid = Capacitor.getPlatform() === 'android';
export const isWeb = !isNative;
